<div class="login-back">
  <div class="container">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
          <div class="card-body">
            <h5 class="card-title text-center">
              <img src="favicon.svg" width="32" style="margin-right: 5px" />
              <span id="loginFormTitle">{{ appTitle }}</span>
            </h5>
            <app-alert></app-alert>
            <cst-tab-sheet
              [selectedTabKey]="selectedTabKey"
              [displayHeader]="false"
            >
              <cst-tab key="login">
                <form
                  [formGroup]="loginForm"
                  (ngSubmit)="OnSubmit()"
                  class="form-signin"
                >
                  <div class="form-signin">
                    <div class="row">
                      <div class="col">
                        <frm-text
                          id="loginUsername"
                          formControlName="username"
                          i18n-label="@@LoginLabelUsername"
                          label="Username"
                        ></frm-text>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <frm-text
                          id="loginPassword"
                          formControlName="password"
                          type="password"
                          i18n-label="@@LabelPassword"
                          label="Password"
                        ></frm-text>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <frm-check
                          i18n-label="@@CheckRememberUsername"
                          label="Remember username"
                          i18n-title="@@CheckRememberUsernameTooltip"
                          title="When this checkbox is active, the username will be saved for the next login."
                          [(ngModel)]="rememberName"
                          [ngModelOptions]="{ standalone: true }"
                        ></frm-check>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col" align="center">
                        <ctrl-btn
                          id="loginSubmit"
                          type="primary"
                          [loading]="loading$ | async"
                          [disabled]="loading$ | async"
                          [default]="true"
                          i18n-content="@@BuLogin"
                          content="Login"
                          (click)="OnSubmit()"
                        ></ctrl-btn>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <a
                          [routerLink]="'/password-forgot'"
                          [queryParams]="GetPasswordForgotQueryParams()"
                          i18n="@@Login_ForgotPassword"
                          >Forgot password?</a
                        >
                      </div>
                    </div>
                  </div>
                </form>
                <form class="form-signin"></form>
              </cst-tab>
              <cst-tab key="tenant-selection">
                <div class="row">
                  <div class="col">
                    <div
                      i18n="@@Login_TenantSelection_Title"
                      class="tenant-selection-header"
                      id="loginTenantSelectionTitle"
                    >
                      Select your tenant
                    </div>
                  </div>
                </div>
                <div class="tenant-selection-wrapper">
                  <div class="tenant-selection-grid">
                    @for (tenant of availableTenants; track tenant) {
                      <div
                        class="tenant-tile"
                        (click)="onTenantSelected(tenant)"
                        [id]="'tenant_' + tenant.domain"
                      >
                        <div class="tenant-tile-title">{{ tenant.name }}</div>
                        <div class="tenant-tile-subtitle">
                          {{ tenant.domain }}
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div class="row" style="padding-top: 20px">
                  <div class="col">
                    <a
                      (click)="
                        $event.preventDefault(); onTenantSelectionCancel()
                      "
                      i18n="@@Login_TenantSelection_BackToLogin"
                      href="/login"
                      >Back to login</a
                    >
                  </div>
                </div>
                <app-spinner-overlay
                  [visible]="loading$ | async"
                ></app-spinner-overlay>
              </cst-tab>
            </cst-tab-sheet>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="position: absolute; left: 0; bottom: 0; right: 0">
    <app-footer [dark]="true" />
  </div>
</div>
